<app-page-bar></app-page-bar>

<app-page>

  <section *ngIf="clientRepresentative$ | async as clientRepresentative">

    <mat-card class="app-card">
      <div class="title">
        <h2>{{!clientRepresentative.id ? "New Representative" : clientRepresentative.first_name + ' ' + clientRepresentative.last_name}}</h2>
        <h3>Representative</h3>
        <p class="small" *ngIf="clientRepresentative.id">Created {{clientRepresentative.created_at | date}}</p>
      </div>
    </mat-card>

    <mat-card class="app-card">
      <div class="header">
        <h3>Information</h3>
      </div>
      <form [formGroup]="form" (ngSubmit)="saveClientRepresentative(clientRepresentative)" novalidate>
        <div class="form-grid">
          <app-text label="SSN" *ngIf="clientRepresentative.masked_ssn">{{ clientRepresentative.masked_ssn }}</app-text>
          <mat-form-field>
            <input matInput placeholder="First Name" formControlName="first_name" [readonly]="!editMode" appAutofocus/>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Last Name" formControlName="last_name" [readonly]="!editMode"/>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Email" formControlName="email" [readonly]="!editMode"/>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Phone" formControlName="phone" [readonly]="!editMode"/>
          </mat-form-field>
          <!-- todo SSN -->
        </div>
        <div class="actions">
          <button type="button" mat-button color="primary" *ngIf="!editMode" (click)="editClientRepresentative()">Edit</button>
          <button type="submit" mat-button color="primary" *ngIf="editMode" [disabled]="!form.valid">Save</button>
          <button type="reset" mat-button *ngIf="editMode" (click)="revertClientRepresentative(clientRepresentative)">Cancel</button>
        </div>
      </form>
    </mat-card>

  </section>

</app-page>
